import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Form,
  Input,
  Typography,
  VertButton,
  VertContainer,
  VertModal,
} from '@vertem-core/vertice-ds';
import { Col, Row } from 'antd';
import * as yup from 'yup';

const VertModalReOpen = ({
  isVisible,
  submitApprove,
  setIsVisible,
  quote = null,
}) => {
  const [form] = Form.useForm();

  const schema = yup.object().shape({
    description: yup.string().required('Comentário é obrigatório'),
  });

  const yupSync = {
    async validator({ field }, value) {
      await schema.validateSyncAt(field, { [field]: value });
    },
  };

  return (
    <VertModal
      title="Reabrir Solicitação"
      open={isVisible}
      onCancel={() => setIsVisible(false)}
      footer={
        <Row justify="space-between">
          <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
            <VertButton
              className="button-view-redemption"
              onClick={() => setIsVisible(false)}
            >
              CANCELAR
            </VertButton>
          </Col>

          <Col xs={10} sm={10} md={10} lg={10} xl={10} xxl={10}>
            <Button
              type="primary"
              danger
              className="button-view-redemption-danger"
              htmlType="submit"
              form="form-quote"
            >
              SIM
            </Button>
          </Col>
        </Row>
      }
    >
      <VertContainer>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography.Text>
            Certeza que deseja{' '}
            <Typography.Text strong> reabrir</Typography.Text> essa solicitação?
          </Typography.Text>

          {quote !== null ? (
            <Typography.Text>
              Ao clicar em
              <Typography.Text
                strong
                style={{
                  margin: '0 5px',
                }}
              >
                SIM
              </Typography.Text>
              ,você estará retornando esta solicitação para novos orçamentos.
            </Typography.Text>
          ) : (
            <Typography.Text>
              {' '}
              Ao clicar em <Typography.Text strong>SIM</Typography.Text> você
              reabrirá o orçamento proposto.
            </Typography.Text>
          )}

          <Form
            style={{
              marginBottom: '20px',
              marginTop: '20px',
              width: '100%',
            }}
            form={form}
            scrollToFirstError
            name="basic"
            initialValues={{ remember: true }}
            autoComplete="off"
            onFinish={submitApprove}
            id="form-quote"
          >
            <Form.Item
              name="description"
              rules={[yupSync]}
              validateTrigger="onBlur"
            >
              <Input.TextArea
                className="modal-text-area"
                placeholder="* Deixe seu comentário"
              />
            </Form.Item>
          </Form>
        </div>
      </VertContainer>
    </VertModal>
  );
};

VertModalReOpen.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  submitApprove: PropTypes.func.isRequired,
  quote: PropTypes.object,
};

export default VertModalReOpen;
